import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

export interface IPasswordManagerCompany {
	companyId: number;
	name: string;
	email?: string | null;
}

const initialState: Array<IPasswordManagerCompany> = [];

const companiesPath = "/passwordManager/Companies";

const buildExternalUrl = () => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	return `${baseUrl.replace(/\/$/, "")}/Companies`;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getCompanies, slice: companiesSlice } = getThunkAndSlice<
	Record<string, never>,
	Array<IPasswordManagerCompany>,
	Array<IPasswordManagerCompany>
>({
	initialState,
	path: companiesPath,
	externalPath: buildExternalUrl,
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
